import config from "./config";
var axios = config();

export default {
  getAllCollaborators(chsOnly) {
    return axios.get("/api/ResearchCollaborators/?chsOnly=" + chsOnly);
  },

  getResearchCollaboratorById(id) {
    return axios.get("/api/ResearchCollaborators/" + id);
  }
};
